export default __webpack_public_path__ + "static/media/640_store01-fr-web.49fcccad.png";